angular.module('rjmNg.api').factory('ConnectionMeta', [
  "$http"
  "$q"
  "phpServiceUrl"
  ($http, $q, phpServiceUrl) ->
    (clientId) ->

      ConnectionMeta = {}

      ConnectionMeta.connection = (metaId) ->
        $http.get(phpServiceUrl("/client/#{clientId}/connectionmeta/#{metaId}"))

      # Use this instead of ConnectionMeta.connection
      ConnectionMeta.get = (metaId, useCache = false) ->
        deferred = $q.defer()
        promise = $http
          method: "GET"
          url: phpServiceUrl("/client/#{clientId}/connectionmeta/#{metaId}?useCache=#{useCache}")
          cache: true
        .then ({data}) ->
          deferred.resolve(data)
        .catch () ->
          deferred.reject()
        return deferred.promise

      ConnectionMeta.status = (metaId, verbose, useCache = false) ->
        deferred = $q.defer()
        $http.get(phpServiceUrl("/client/#{clientId}/connectionmeta/status/#{metaId}?verbose=#{verbose}&useCache=#{useCache}"))
        .then (result) ->
          deferred.resolve(result.data)
        , (err) ->
          deferred.reject err
        return deferred.promise

      ConnectionMeta.getDependents = (metaId) ->
        $http.get(phpServiceUrl("/client/#{clientId}/connectionmeta/dependents/#{metaId}"))

      ConnectionMeta.deleteConnection = (metaId) ->
        $http.post(phpServiceUrl("/client/#{clientId}/connectionmeta/delete/#{metaId}"))

      ConnectionMeta.save = (connection) ->
        if(connection.id)
          $http.post(phpServiceUrl("/client/#{clientId}/connectionmeta/update/#{connection.id}"), connection)
        else
          $http.post(phpServiceUrl("/client/#{clientId}/connectionmeta/create/"), connection)

      ConnectionMeta.gaConnections = () ->
        deferred = $q.defer()
        $http
          method: "GET"
          url: phpServiceUrl("/client/#{clientId}/connectionmeta/")
          cache: true
        .then ({data}) ->
          # Filter just the GA Connections
          ga = []
          ga.push conn for conn in data when conn.meta.connection?.type in ["google_analytics", 'google_analytics4_live']
          deferred.resolve(ga)
        .catch () ->
          deferred.reject()
        return deferred.promise

      ConnectionMeta
  ]
)
